export default __webpack_public_path__ + "static/media/icon-kupon-tersedia.76d8d7e2.png";